module.exports = __webpack_public_path__ + "img/20201013_151352.94549e76.jpg";